module.exports = __webpack_public_path__ + "img/life-brand.c741c6ea.jpg";